import { gql } from '@apollo/client';

// export const FETCH_SEASON_BY_SERIES_ID = gql`
//     query FetchSeasonBySeriesId($series_id: String!) {
//         fetchSeasonBySeriesId(series_id: $series_id) {
//             data {
//                 seasons {
//                     title
//                     series_id
//                     folder_id
//                     id
//                 }
//             }
//             error {
//                 message
//             }
//         }
//     }
// `;

export const FETCH_SEASON_BY_SERIES_ID = gql`
   query FetchSeasonBySeriesId($series_id:UUID!) {
    fetchSeasonBySeriesId(series_id: $series_id) {
        data {
            seasons {
                created_at
                folder_id
                id
                label
                series_id
                title
                updated_at
            }
        }
        error {
            code
            field
            message
        }
    }
}
`;


